import * as React from 'react'

import isEqual from 'lodash/isEqual'
import keyBy from 'lodash/keyBy'

import type { CompetencyAssessment } from 'modules/reviews/store/models/QuestionGroup'

type IndexedAssessments = Record<number, CompetencyAssessment>

const useCompetencyAssessments = (assessments: CompetencyAssessment[]) => {
  const [changed, setChanged] = React.useState(false)
  const [indexedAssessments, setIndexedAssessments] = React.useState<IndexedAssessments>(
    keyBy(assessments, 'id')
  )

  const competenciesAssessments = Object.values(indexedAssessments)

  const handleCompetencyAssessmentUpdate = (assessment: CompetencyAssessment) => {
    setIndexedAssessments((prevState) => {
      const previousValue = prevState[assessment.id]
      if (previousValue) {
        hasChanged(assessment, previousValue)
      }

      return {
        ...prevState,
        ...{ [assessment.id]: assessment },
      }
    })
  }

  const hasChanged = (oldAssessment: CompetencyAssessment, newAssessment: CompetencyAssessment) => {
    const equal = isEqual(oldAssessment, newAssessment)
    if (!equal) {
      setChanged(true)
    }
  }

  const assessmentsAnswered = competenciesAssessments.every((x) => x.competency_option_id !== null)

  const resetCompetencyAssessments = (newAssessments: CompetencyAssessment[]) => {
    setIndexedAssessments(keyBy(newAssessments, 'id'))
  }

  return {
    competencyAssessments: competenciesAssessments,
    updateCompetencyAssessment: handleCompetencyAssessmentUpdate,
    competencyAssessmentsChanged: changed,
    competencyAssessmentsAnswered: assessmentsAnswered,
    resetCompetencyAssessments,
  }
}

export default useCompetencyAssessments
